import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import Popover from "@mui/material/Popover";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import NotificationsIcon from "@mui/icons-material/Notifications";
import CircleIcon from "@mui/icons-material/Circle";

const BASE = process.env.REACT_APP_BASE_URL;

export default function TicketNotificationBell() {
  const [count, setCount] = useState(0);
  const [items, setItems] = useState([]);
  const [anchor, setAnchor] = useState(null);
  const navigate = useNavigate();
  const timer = useRef(null);
  const token = localStorage.getItem("token");

  const fetchCount = async () => {
    try {
      const res = await fetch(`${BASE}admin/tickets/unread-count`, { headers: { Authorization: token } });
      const data = await res.json();
      setCount(data.count || 0);
    } catch (_) {}
  };

  const fetchList = async () => {
    try {
      const res = await fetch(`${BASE}admin/tickets/unread-list`, { headers: { Authorization: token } });
      const data = await res.json();
      setItems(data.items || []);
    } catch (_) {}
  };

  const markSeen = async () => {
    try {
      await fetch(`${BASE}admin/tickets/mark-seen`, { method: "POST", headers: { Authorization: token } });
      setCount(0);
    } catch (_) {}
  };

  useEffect(() => {
    fetchCount();
    timer.current = setInterval(fetchCount, 30000);
    return () => clearInterval(timer.current);
  }, []);

  const handleOpen = async (e) => {
    setAnchor(e.currentTarget);
    await fetchList();
    await markSeen();
  };

  const handleClose = () => setAnchor(null);

  const handleItemClick = (item) => {
    handleClose();
    const ticketId = item.type === "new_ticket" ? item.id : item.ticketId;
    navigate(`/messages/${ticketId}`);
  };

  return (
    <>
      <IconButton color="inherit" onClick={handleOpen}>
        <Badge badgeContent={count} color="error" max={99}>
          <NotificationsIcon />
        </Badge>
      </IconButton>
      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{ style: { width: 360, maxHeight: 480 } }}
      >
        <div style={{ padding: "12px 16px", background: "#1976d2" }}>
          <Typography style={{ color: "#fff", fontWeight: 700, fontSize: 15 }}>Support Ticket Notifications</Typography>
        </div>
        {items.length === 0 ? (
          <div style={{ padding: 24, textAlign: "center" }}>
            <Typography color="textSecondary">No new notifications</Typography>
          </div>
        ) : (
          <List dense disablePadding>
            {items.map((item, i) => (
              <React.Fragment key={i}>
                <ListItem button onClick={() => handleItemClick(item)} style={{ alignItems: "flex-start", padding: "10px 16px" }}>
                  <CircleIcon style={{ fontSize: 8, color: item.type === "new_ticket" ? "#f44336" : "#1976d2", marginTop: 6, marginRight: 10, flexShrink: 0 }} />
                  <ListItemText
                    primary={<Typography style={{ fontSize: 14, fontWeight: 600 }}>{item.type === "new_ticket" ? `New ticket: ${item.subject || "No subject"}` : `Reply on: ${item.ticketSubject}`}</Typography>}
                    secondary={<span><Typography component="span" style={{ fontSize: 12, color: "#666", display: "block" }}>{item.type === "new_ticket" ? `From: ${item.name || item.email || "User"}` : "User replied"}</Typography><Typography component="span" style={{ fontSize: 11, color: "#999" }}>{new Date(item.createdAt).toLocaleString()}</Typography></span>}
                  />
                </ListItem>
                {i < items.length - 1 && <Divider />}
              </React.Fragment>
            ))}
          </List>
        )}
        <Divider />
        <div style={{ padding: "8px 16px", textAlign: "center", cursor: "pointer" }} onClick={() => { handleClose(); navigate("/messages"); }}>
          <Typography style={{ fontSize: 13, color: "#1976d2", fontWeight: 600 }}>View all tickets →</Typography>
        </div>
      </Popover>
    </>
  );
}
